/* eslint-disable indent */
import { Link, useNavigate } from 'react-router-dom';
import { useUser } from '../../../hooks/useUser';
import { EventDetails } from '../../../interfaces/userInterfaces';

interface CalandarEventsProps {
  dateOfEvent?: Date;
  eventList?: EventDetails[];
}

export const CalendarEvents: React.FC<CalandarEventsProps> = ({ dateOfEvent, eventList }) => {
  // dateOfEvent is set in Calendar when user clicks on a day cell
  // eventList is anArray of Events being attended by the Calendar owner
  // Calendar owner is either the logged in user, or from a Public Profile
  const { user, userAttendingEventsList } = useUser();

  // create Array of Event IDs to determine if User is attending an Event
  // Check is performed below
  // const usersEvents = user
  //   ? user.attending_event?.map((event) => {
  //       return event.event_id;
  //     })
  //   : null;
  return (
    <>
      {eventList?.map((event, i) => {
        let attending = false;
        // attending is used in the Event Flyer to determine what user actions
        // are available. Choices are:
        // attending === false Add To attending or,
        // attending === true Remove From Attending
        if (userAttendingEventsList?.includes(event.id)) attending = true;

        // Compare current iteration date to modal date
        // if true, add link to events Event Flyer in modal
        const eventDateObj = new Date(`${event.date}T${event.time}`);
        if (eventDateObj.toDateString() === dateOfEvent?.toDateString()) {
          return (
            <div key={event.date + i} id="modal-event-list-item">
              <img
                id="modal-event-list-item-image"
                src={
                  event?.promotional_image ||
                  'https://nqbvdgzoxvmdlnjovyqu.supabase.in/storage/v1/object/public/avatars/default-avatar/userexpression.png'
                }
              />
              <Link to={`../event/${event.id}/${attending}`} id="modal-event-list-item-name">
                {event.event_name}
              </Link>
            </div>
          );
        } else {
          return null;
        }
      })}
    </>
  );
};
